import React from 'react';
import { useViewlogies } from 'context';
import './banner.scss';
import { getCorrectedUrl } from '../../utils.js';
import DonationButton from './DonationButton';

const PlantATree = () => {
    const {
        event: { organizationId, obituaryUrl, videoCTA, firstName, lastName, color = '#000' },
    } = useViewlogies();

    const getTreeLink = (obituaryUrl, organizationId) => {
        try {
            const queryParams = obituaryUrl ? new URLSearchParams(new URL(obituaryUrl).search) : undefined;
            const obituaryId = queryParams.get('obId') || queryParams.get('oId');

            let treeLink = '';
            if (obituaryId) {
                treeLink = `https://tree.tributestore.com/memorial-tree?oId=${obituaryId}`;
            } else {
                return '';
            }

            if (organizationId) {
                treeLink = `${treeLink}&utm_source=${organizationId}-viewlogies`;
            } else {
                treeLink = `${treeLink}&utm_source=viewlogies`;
            }

            treeLink += '&utm_medium=referral&utm_campaign=tt_viewlogies&utm_content=plant-a-tree';
            return treeLink;
        } catch (e) {
            return undefined;
        }
    };

    const treeLink = getTreeLink(obituaryUrl, organizationId);
    const correctedTreeUrl = getCorrectedUrl(treeLink);
    const plantATree = videoCTA === 'Plant A Tree Tribute Store';
    const personName = [firstName, lastName].filter(Boolean).join(' ') || 'the deceased';
    const treeText = `Plant a tree in ${personName}'s name...`;

    return (
        <>
            {correctedTreeUrl && plantATree && (
                <div className="donation-box">
                    <div className="donation-header">{treeText}</div>
                    <DonationButton href={correctedTreeUrl} label="PLANT A TREE" color={color} />
                </div>
            )}
        </>
    );
};

export default PlantATree;
